import { noPropagate, noDefault } from '../utils'

export const walkFilterPath = (path, root, nextCB) => {
  const depth = path.length
  let tree = root

  if (tree) {
    for (let i = 0; i < depth; i += 1) {
      if (tree) {
        tree = nextCB(tree, i)
      }
    }
  }
}

export const flatten = (tree, ancestors = []) =>
  tree.reduce(
    (prev, cur) => [
      ...prev,
      {
        ...cur,
        ancestors,
      },
      ...flatten(cur.childOptions || [], ancestors.concat(cur)),
    ],
    []
  )

export const findCurrentTree = (currentPath, rootTree) => {
  const path = currentPath || []
  const depth = path.length
  let tree = rootTree

  if (tree) {
    for (let i = 0; i < depth; i += 1) {
      if (tree) {
        tree = tree.find((subtree) => subtree.id === path[i])
        if (tree && tree.childOptions) {
          tree = [tree, ...tree.childOptions]
        }
      }
    }
  }
  return tree
}

export const stopped = (method) => (e) => noPropagate(noDefault(method(e)))

// There is inconsistency between what a filter status is
// called and what content gets assigned.
const approvalStatusesMap = {
  approved: 'approved',
  declined: 'denied',
  denied: 'needs_revision',
  draft: 'draft',
  pending: 'for_approval',
  published: 'published',
}

const buildSingleFilter = (filter, key, allFiltersDisabled) => ({
  id: filter.payload.object.id ? filter.payload.object.id.toString() : key,
  disabled: allFiltersDisabled || filter.disabled,
})

export const addFilter = (
  filter,
  currentSelections = [],
  allFiltersDisabled
) => {
  const current = [...currentSelections]
  current.push(buildSingleFilter(filter, null, allFiltersDisabled))
  return current
}

export const addStatusFilter = (
  filter,
  selectedStatuses = [],
  allFiltersDisabled
) => {
  const statuses = [...selectedStatuses]
  const sanitizedFilter = { ...filter }
  const status = approvalStatusesMap[filter.payload.object.status] || 'idea'

  sanitizedFilter.payload.object.status = status
  statuses.push(
    buildSingleFilter(
      sanitizedFilter,
      sanitizedFilter.payload.object.status,
      allFiltersDisabled
    )
  )
  return statuses
}

export const addLabelSetFilter = (
  filter,
  selectedLabels = {},
  allFiltersDisabled
) => {
  const labelsGroupedBySet = { ...selectedLabels }

  if (labelsGroupedBySet[filter.payload.object.label_set_id]) {
    labelsGroupedBySet[filter.payload.object.label_set_id] = [
      ...labelsGroupedBySet[filter.payload.object.label_set_id],
      buildSingleFilter(filter, null, allFiltersDisabled),
    ]
    return labelsGroupedBySet
  }

  labelsGroupedBySet[filter.payload.object.label_set_id] = [
    buildSingleFilter(filter, null, allFiltersDisabled),
  ]

  return labelsGroupedBySet
}
